import React, { useEffect, useState } from 'react';
import './footer.css';
import { motion } from 'framer-motion';
import PageMenu from '../menu/PageMenu.jsx';
import { imageData, visibilitySetting } from '/src/constants/constants.jsx';
import { useTheme } from '../context/ThemeContext.jsx';

const Footer = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);
    const { theme } = useTheme();

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        // Show button if scrolled down more than 50px
        setShowScrollTop(scrollTop > 50);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const bounceAnimation = {
        initial: { y: 0 },
        animate: { y: [0, -20, 0] },
        transition: {
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop',
        },
    };

    return (
        <div className={`footer_block ${theme === 'Dark' ? 'dark-theme' : ''}`}>
            <div className="max-w-custom mx-auto pb-14 footer_main">
                <div className="footer_top_row">
                    <div className="footer_logo_section">
                        <img 
                            src={theme === 'Dark' ? imageData.logo_img : imageData.logo_img_light}
                            alt="Logo" 
                        />
                    </div>
                    <div className="footer_menu_section">
                        <PageMenu />
                    </div>
                    {/*<div className="footer_email_section">*/}
                    {/*    <a href="mailto:support@lidaratlas.com" className="footer_email_link">*/}
                    {/*        Email us: support@lidaratlas.com*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
                <div className="footer_bottom flex items-center justify-between">
                    <div className="footer_bottom_left">
                        <p className="text-sm font-normal">
                            Copyright © 2025 Advanced Algorithms LLC. A California company.
                        </p>
                        <p className="text-sm font-normal">
                            All rights reserved
                        </p>
                    </div>
                    <div className="footer_bottom_left footer_bottom_right">
                        <p className="text-sm font-normal">
                            Terms of Use | Privacy Policy
                        </p>
                    </div>
                </div>
                <div className="scroll_footer_box">
                    {showScrollTop && (
                        <motion.img
                            src={imageData.scroll_top_icon}
                            alt="scroll_top"
                            className="scroll_top_img"
                            onClick={scrollToTop}
                            {...bounceAnimation}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Footer;
